import { render } from "./CustomFormPromptDialogContent.vue?vue&type=template&id=4577a1b0"
import script from "./CustomFormPromptDialogContent.vue?vue&type=script&lang=js"
export * from "./CustomFormPromptDialogContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__